import { pageSelectorGenerator } from '@test/pageSelectors';

export const CancelGiftIntentSelectors = pageSelectorGenerator('CancelGiftIntent', ['ContainerElement', 'AffirmativeButton', 'NegativeButton']);
